import React from 'react';
import styled from 'styled-components';


const NextIcon = () => {
  return (
      <>
          <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
              <g id="Arrow" transform="translate(-648 -1595.793)">
                  <g id="Group_4823" data-name="Group 4823" transform="translate(653.5 1596.5)">
                      <line id="Line_9" data-name="Line 9" x2="5" y2="5" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                      <line id="Line_10" data-name="Line 10" x1="5" y2="5" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                  </g>
                  <line id="Line_11" data-name="Line 11" x2="10" transform="translate(648.5 1601.5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
              </g>
          </svg>
      </>
  );
};


export default React.memo(NextIcon);
